import Config from '../Config';
import { RestService } from './RestService';

export const ImportService = {
    uploadMap: async function(organisation, body){
        return RestService.post(`${Config.upload_map_url}organisation=${organisation}`, {}, body)
        .then(response => response.json())
    },
};